import emptyDataPic from 'static/images/emptyData.png';
import './style.scss';

interface EmptyDataProps {
    emptyText?: React.ReactNode;
}

const EmptyData: React.FC<EmptyDataProps> = ({ emptyText }) => {
    return (
        <div className="empty-data-root">
            <img className="empty-img" src={emptyDataPic} alt="no-data" />
            <div>{emptyText || __('暂无数据')}</div>
        </div>
    );
};

export default EmptyData;
